<template lang="html">
  <v-container>
    <v-card>
      <v-inner>
        <!-- CUSTOMER SIGNING -->
        <div v-if="profile === 'client'">
          <span v-html="client_contract_head_model.template"></span>

          <span v-html="client_contract_body_model.template"></span>

          <p>
            Por estarem assim justas e contratadas, as partes declaram aceitar
            expressamente as cláusulas supra e firmam o presente instrumento.
          </p>

          <v-divider line />

          <v-text tag="h5"><b>ANEXO I:</b></v-text>

          <p>
            <b>PERFIL PROFISSIONAL CONTRATADO:</b>
            {{ contract.vibbrante.profile + ' ' + contract.vibbrante.focus }}.
          </p>

          <p>
            <b>QUANTIDADE DE HORAS CONTRATADAS:</b>
            {{ contract.expect_hours }} horas.
          </p>

          <p>
            <b>VALOR DA HORA CONTRATADO:</b>
            {{ contract.hour_value | currency }}.
          </p>

          <p>
            <b>DISPONIBILIDADE PARA INÍCIO DOS TRABALHOS:</b>
            {{ contract.expected_start_date | moment('DD/MM/YYYY') }}.
          </p>
        </div>

        <!-- VIBBRANTE/FREELANCER SIGNING -->

        <div v-if="profile === 'vibbrant'">
          <span v-html="vibbrante_contract_head_model.template"></span>

          <span v-html="vibbrante_contract_body_model.template"></span>

          <p>
            Por estarem assim justas e contratadas, as partes declaram aceitar
            expressamente as cláusulas supra e firmam o presente instrumento.
          </p>

          <v-divider line />

          <v-text tag="h5"><b>ANEXO I:</b></v-text>

          <p>
            <b>PERFIL PROFISSIONAL CONTRATADO:</b>
            {{ contract.vibbrante.profile + ' ' + contract.vibbrante.focus }}.
          </p>

          <p>
            <b>QUANTIDADE DE HORAS CONTRATADAS:</b>
            {{ contract.expect_hours }} horas.
          </p>

          <p><b>VALOR DA HORA CONTRATADO:</b></p>
          <v-row :size="2">
            <v-col :xs="12" :sm="12" :md="6" :lg="2">
              <v-input
                type="money"
                v-model="contract.expected_hour_value_vibbrante"
                disabled
                >Valor/hora padrão</v-input
              >
            </v-col>
            <v-col :xs="12" :sm="12" :md="6" :lg="3">
              <v-input
                type="money"
                :min="0"
                :max="hour_val"
                :disabled="profile === 'client'"
                v-model="contract.hour_value_vibbrante"
                helptext="Preencher somente se deseja aplicar um valor promocional para esse contrato"
                >Valor/hora promocional</v-input
              >
            </v-col>
          </v-row>

          <p><b>HORAS DISPONÍVEIS POR SEMANA:</b></p>
          <v-row :size="2">
            <v-col :xs="12" :sm="12" :md="6" :lg="3">
              <v-input
                type="integer"
                :min="1"
                :disabled="profile === 'client'"
                v-model="contract.hour_available"
                helptext="Altere esse valor para informar o cliente sobre sua real disponibilidade"
                >Horas por semana</v-input
              >
            </v-col>
          </v-row>

          <p><b>DATA DE INÍCIO DOS TRABALHOS:</b></p>
          <v-row :size="2">
            <v-col :xs="12" :sm="12" :md="6" :lg="4">
              <v-input
                :disabled="profile === 'vibbrant' ? false : true"
                v-model="contract.expected_start_date"
                type="datepicker"
                helptext="Para o caso de não haver disponibilidade para início imediato do Vibbrante"
                >Data início prevista</v-input
              >
            </v-col>
          </v-row>
        </div>

        <v-divider line />

        <p v-if="profile === 'vibbrant'">
          Florianópolis/SC,
          {{ contract.signed_date_vibbrante | moment('DD') }} de
          {{ contract.signed_date_vibbrante | moment('MMMM') }} de
          {{ contract.signed_date_vibbrante | moment('YYYY') }}.
        </p>
        <p v-else>
          Florianópolis/SC, {{ contract.signed_date_client | moment('DD') }} de
          {{ contract.signed_date_client | moment('MMMM') }} de
          {{ contract.signed_date_client | moment('YYYY') }}.
        </p>

        <div v-if="profile === 'client'">
          <v-input
            class="mb-1"
            id="termsCheck"
            v-model="contract.accept_terms_client"
            type="checkbox"
            @change="terms_check = !terms_check"
            >Declaro que li e aceito as cláusulas desse contrato.</v-input
          >
        </div>
        <div v-else>
          <v-input
            class="mb-1"
            id="termsCheck"
            v-model="contract.accept_terms_vibbrante"
            type="checkbox"
            @change="terms_check = !terms_check"
            >Declaro que li e aceito as cláusulas desse contrato.</v-input
          >
        </div>

        <v-divider :size="2" line />

        <v-button
          class="primary mt-3"
          :disabled="!terms_check"
          @click="signContract()"
          >Assinar contrato</v-button
        >
      </v-inner>
    </v-card>
  </v-container>
</template>

<script>
import Contract from '@/parts/modules/contract';
import apiVibbrante from '@/api/vibbrante';
import apiClient from '@/api/client';

export default {
  props: {
    profile: String,
    contract: {},
    vibbrante: {},
    client: {},
    vibbrante_contract_body_model: {},
    vibbrante_contract_head_model: {},
    client_contract_body_model: {},
    client_contract_head_model: {},
  },
  components: {
    'v-contract': Contract,
  },
  data() {
    return {
      is_pf: false,
      terms_check: false,
      hour_val: 60,
      hour_discount: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.profile === 'vibbrant') {
        apiVibbrante
          .vibbranteGetContract(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              this.contract = response.data;
              this.$store.dispatch(
                'loadVibbranteCurrentContract',
                response.data
              );
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
        apiVibbrante
          .getVibbranteData()
          .then(response => {
            if (response.status === 200) {
              this.vibbrante = response.data;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
        apiVibbrante
          .vibbranteGetContractModels(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              console.log(response.data);
              response.data.forEach(element => {
                if (element.apply_to.includes('vibbrante_head')) {
                  this.vibbrante_contract_head_model = element;
                }
                if (element.apply_to.includes('vibbrante_body')) {
                  this.vibbrante_contract_body_model = element;
                }
              });
            }
          });
      } else {
        apiClient
          .clientGetContract(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              this.contract = response.data;
              this.$store.dispatch('loadClientCurrentContract', response.data);
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
        apiClient
          .getClientData()
          .then(response => {
            if (response.status === 200) {
              this.client = response.data;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
        apiClient
          .clientGetContractModels(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              console.log(response.data);
              response.data.forEach(element => {
                if (element.apply_to.includes('client_head')) {
                  this.client_contract_head_model = element;
                }
                if (element.apply_to.includes('client_body')) {
                  this.client_contract_body_model = element;
                }
              });
            }
          });
      }
    },
    signContract() {
      if (this.profile === 'vibbrant') {
        // this.contract.expected_start_date = this.$moment(this.contract.expected_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

        apiVibbrante
          .vibbranteAcceptContract(this.contract)
          .then(response => {
            if (response.status === 200) {
              apiVibbrante
                .loadPendingContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadVibbranteWaitingAnswerContracts',
                      response.data
                    );
                    this.$router.push({ name: 'vibbrant-clients-pending' });
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });

              apiVibbrante
                .loadActivesContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadVibbranteActivesContracts',
                      response.data
                    );
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        let pj_or_pf = 'PJ';
        if (this.is_pf) {
          pj_or_pf = 'PF';
        }
        apiClient
          .clientActivedContract(this.contract.id, pj_or_pf)
          .then(response => {
            if (response.status === 200) {
              apiClient
                .loadPendingContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadClientWaitingAnswerContracts',
                      response.data
                    );
                    this.$router.push({ name: 'client-vibbrants-pending' });
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
  },
  computed: {
    fullName() {
      return this.contract.client.name + ' ' + this.contract.client.lastname;
    },
    fullAddress() {
      return (
        this.contract.client.address + ' ' + this.contract.client.address_number
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/components/vibbrante-contract.vue